import { render, staticRenderFns } from "./CardBadge.vue?vue&type=template&id=3588b6fb&scoped=true&"
import script from "./CardBadge.vue?vue&type=script&lang=js&"
export * from "./CardBadge.vue?vue&type=script&lang=js&"
import style0 from "./CardBadge.vue?vue&type=style&index=0&id=3588b6fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3588b6fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
